import getRightsManagementLicenseData from '../services/getRightsManagementLicenseData';
import { ObservableMap } from 'mobx';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import mailStore from 'owa-mail-store/lib/store/Store';
import Item from 'owa-service/lib/contract/Item';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import { action, select } from 'satcheljs/lib/legacy';

const irmInfoBarMessageId = 'irmInfoBar';

export interface ReloadRightsManagementLicenseDataState {
    items: ObservableMap<string, Item>;
}

function updateItemViewState(
    rightsManagementLicenseData: RightsManagementLicenseDataType,
    itemInCache: Item,
    viewState: ItemViewState
) {
    viewState.loadingState.isLoading = false;
    if (rightsManagementLicenseData) {
        itemInCache.RightsManagementLicenseData = rightsManagementLicenseData;
    }
}

export default action('reloadRightsManagementLicenseData')(
    select<ReloadRightsManagementLicenseDataState>({
        items: () => mailStore.items,
    })(async function reloadRightsManagementLicenseData(
        viewState: ItemViewState,
        itemId: string,
        state?: ReloadRightsManagementLicenseDataState
    ) {
        const item = state.items.get(itemId);
        removeInfoBarMessage(viewState, irmInfoBarMessageId);
        viewState.loadingState.isLoading = true;
        const reloadedRightsManagementData = await getRightsManagementLicenseData(itemId);
        updateItemViewState(reloadedRightsManagementData, item, viewState);
    })
);
